<template>
  <div class="nch--blog-posts">
    <Card class="nch-blog-items">
      <h2>{{ $t('blog.posts.latest') }}</h2>
      <form class="nch--blog-search" @submit.prevent="getPosts">
        <input
          :placeholder="$t('blog.posts.search')"
          v-model="pagination.search"
        />
        <Button :disabled="loading" :title="$t('blog.posts.search')">
          <i class="mdi mdi-magnify"></i>
        </Button>
      </form>
      <PostCard
        v-for="post in posts"
        :key="post.id"
        :value="post"
      />
      <span v-if="!posts.length">{{ $t('blog.posts.no_data') }}</span>
    </Card>
  </div>
</template>
<script>
import Card from '../../../common/Card';
import Button from '../../../common/Button';
import PostCard from '../../../PostCard';

export default {
  name: 'Header',
  components: {
    Card,
    Button,
    PostCard,
  },
  data: () => ({
    posts: [],
    pagination: {
      page: 1,
      search: '',
    },
  }),
  beforeMount() {
    this.getPosts();
  },
  mounted() {
    document.addEventListener('scroll', async () => {
      const { scrollTop, offsetHeight } = document.documentElement;
      const bottomOfWindow = scrollTop + window.innerHeight > offsetHeight - 20;
      const lastpage = this.pagination.current_page === this.pagination.last_page;
      if (bottomOfWindow && !this.loading && !lastpage) {
        await this.nextPage();
      }
    });
  },
  methods: {
    nextPage() {
      this.pagination.page += 1;
      return this.getPosts();
    },
    async getPosts(e) {
      try {
        this.loading = true;
        if (e && e.type === 'submit') {
          this.posts = [];
        }
        const { data } = await window.axios
          .get('/api/blog/posts/list', {
            params: this.pagination,
          });
        this.posts = [...this.posts, ...data.data];
        this.pagination = { ...this.pagination, ...data.meta };
        this.pagination.page = this.pagination.current_page;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.nch--blog-posts{
  width: 100%;
  display: flex;
}
.nch-blog-items h2 {
  font-size: 1.7rem;
  width: 100%;
  text-align: left;
  color: var(--blog-text);
}
.nch-blog-items{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: flex-start;
  width: 100%;
}
.nch--blog-search {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.5rem 1rem;
}
.nch--blog-search input{
  flex-grow: 1;
  border: 1px solid var(--blog-border);
  padding: 0.9rem;
  border-radius: 8px;
}
.nch--blog-search button {
  margin-left: .5rem;
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  padding: 0;
  align-items: center;
  justify-content: center;
}
.nch--blog-search button > i {
  font-size: 1.3rem;
}
</style>
